import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { UiCheckCircle, UiExclamationCircle, UiTimesCircle } from '@vyaguta/vyaguta-icons/ui';

import 'react-toastify/dist/ReactToastify.css';

const ICON_SIZE = 20;

type ToastStatusType = 'success' | 'warning' | 'danger' | (string & {});

type ToastMessage = {
  title?: React.ReactNode;
  message?: React.ReactNode;
};

interface CustomToastProps {
  statusType: ToastStatusType;
  toastMessage: ToastMessage;
  toastClassName?: string;
}

const CustomToast: React.FC<CustomToastProps> = ({ statusType, toastMessage, toastClassName }) => {
  const toasts = {
    success: {
      className: 'success',
      icon: <UiCheckCircle size={ICON_SIZE} />,
    },
    warning: {
      className: 'warning',
      icon: <UiExclamationCircle size={ICON_SIZE} />,
    },
    danger: {
      className: 'danger',
      icon: <UiTimesCircle size={ICON_SIZE} />,
    },
  };

  const toastConfig = toasts[statusType] as { className: string; icon: React.ReactNode } | undefined;

  return (
    <div>
      {toastConfig && toastConfig !== undefined && (
        <div className={`lf-toast lf-toast--${toastConfig.className} ${toastClassName}`}>
          <div className="lf-toast__icon">{toastConfig.icon}</div>
          <div className="lf-toast__content">
            <span className="lf-toast__title">{toastMessage.title}</span>
            <p className="lf-toast__message">{toastMessage.message}</p>
          </div>
        </div>
      )}
    </div>
  );
};

interface NotifyProps {
  type: ToastStatusType;
  data: ToastMessage;
  autoClose?: number;
  draggable?: boolean;
  className?: string;
}

export const notify = (props: NotifyProps) => {
  const { type, data, autoClose, draggable, className = '' } = props;
  toast(<CustomToast statusType={type} toastMessage={data} toastClassName={className} />, {
    autoClose: autoClose || 3000,
    draggable: draggable || false,
    closeButton: false,
    progressClassName: 'lf-toast__progress-bar',
    className: className,
    hideProgressBar: true,
  });
};

export default function Toast() {
  return <ToastContainer className="lf-toast__container" />;
}
